import { OPTIONS_INTEGRATION } from 'app-constants'
import { http } from 'hooks'

export function wifiService() {
  function updateWifi(idContract, data) {
    return http.put(`/v1/services/wifi/${idContract}`, data, OPTIONS_INTEGRATION)
  }

  function getInternet(idContract) {
    return http.get(`/v1/services/internet/${idContract}`, OPTIONS_INTEGRATION)
  }

  function getConnectionStatusRequest(params) {
    return http.get('/v1/contracts/connection-status', {
      params,
      ...OPTIONS_INTEGRATION,
    })
  }

  return {
    updateWifi,
    getInternet,
    getConnectionStatusRequest,
  }
}
